export const ATTENTION_ANALYSIS_OPENED = 'ATTENTION_ANALYSIS_OPENED';

export const INIT_FACE_DETECT = 'INIT_FACE_DETECT';

export const START_FACE_DETECT = 'START_FACE_DETECT';

export const STOP_FACE_DETECT = 'STOP_FACE_DETECT';

export const UPDATE_ATTENTION_STATUS = 'UPDATE_ATTENTION_STATUS';

export const SET_ATTENTION_ANALYSIS_READY = 'SET_ATTENTION_ANALYSIS_READY';

export const SET_ATTENTION_ANALYSIS_COUNT = 'SET_ATTENTION_ANALYSIS_COUNT';

export const SET_ATTENTION_ANALYSIS_TOTAL = 'SET_ATTENTION_ANALYSIS_TOTAL';

export const SET_STATUS_MAP = 'SET_STATUS_MAP';
